import Box from '@mui/material/Box'
import { styled } from '@mui/system'
import { tooltipClasses } from '@mui/material/Tooltip'

import { TypographyWrap } from '../../../../../../components/TypographyWrap'
import { BootstrapTooltip } from '../../../../../../components/BootstrapTooltip'
import { UserInitialPswdCopyBtn } from '../../../../../../components/AppUserInitialPswd/styled'

interface CoachOverviewHeadInfoBoxProps {
	readonly showInitialPswd?: boolean
}

const CoachOverviewHeadInfoBox = styled(Box, {
	shouldForwardProp: prop => prop !== 'showInitialPswd',
})<CoachOverviewHeadInfoBoxProps>(({ theme, showInitialPswd }) => ({
	display: 'grid',
	gap: '1.5rem',
	alignContent: 'center',
	borderRadius: '1rem',
	boxShadow: '0 0.1875rem 0.8rem 0 rgba(53, 61, 69, 0.2)',
	marginTop: '1.25rem',
	paddingTop: '1.4rem',
	paddingBottom: '1.5rem',
	border: `1px solid ${theme.palette.grey[300]}`,
	[theme.breakpoints.up('xl')]: {
		paddingRight: '1.8rem',
		paddingLeft: '1.8rem',
		gridTemplateColumns: `1fr ${showInitialPswd ? '22rem' : ''} 7.6875rem`,
	},
	[theme.breakpoints.between('lgx', 'xl')]: {
		paddingRight: '2.25rem',
		paddingLeft: '1.8rem',
		gridTemplateColumns: `1fr ${showInitialPswd ? '19rem' : ''} 7.6875rem`,
	},
	[theme.breakpoints.between('xs', 'lgx')]: {
		paddingRight: '2.6rem',
		paddingLeft: '2rem',
		gridTemplateColumns: `1fr ${showInitialPswd ? '17rem' : ''} 7.6875rem`,
	},
}))

const CoachOverviewHeadInfoName = styled(TypographyWrap)(() => ({
	fontSize: '1.1875rem',
	fontWeight: 600,
	margin: 0,
}))

const CoachInitialPswdTooltip = styled(BootstrapTooltip)(() => ({
	[`& .${tooltipClasses.tooltip}`]: {
		fontSize: '0.75rem',
	},
}))

const CoachInitialPswdCopyBtn = styled(UserInitialPswdCopyBtn)``

const CoachinitialPswdLeftBlock = styled(Box)`
	display: flex;
	align-items: center;
	overflow: hidden;
`

const CoachOverviewHeadWrapper = styled(Box)(({ theme }) => ({
	padding: '2rem 2rem 0 2rem',
	borderBottom: '1.5rem',
	borderColor: theme.palette.secondary.main,
	backgroundColor: theme.palette.common.white,
}))

export {
	CoachOverviewHeadInfoBox,
	CoachOverviewHeadInfoName,
	CoachInitialPswdTooltip,
	CoachInitialPswdCopyBtn,
	CoachinitialPswdLeftBlock,
	CoachOverviewHeadWrapper,
}
